module.exports = __webpack_public_path__ + "color.c7a33805ffda0d32bd2a.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/primeng/resources/images/color.png
// module id = ../../../../primeng/resources/images/color.png
// module chunks = 17